<template>
  <login-layout
    class="login-container"
    :title="title"
  >
    <div
      class="account-tel-login"
    >
      <div class="login-tab">
        <h3
          v-if="loginType === 1 || loginType === 2"
          class="login-tit"
        >
          {{ loginTit }}
        </h3>
        <account-login v-if="loginType === 1" />
        <tel-login v-else-if="loginType === 2" />
        <template v-else>
          <qw-login
            v-if="isReady"
            :url="qwLoginUrl"
          />
        </template>
      </div>
      <div class="other-login">
        <h4> {{ $t('message["1892"]') }}</h4>
        <p>
          <a
            v-if="loginType !== 3"
            :disabled="!isReady"
            href="javascript:;"
            @click="toLink(3)"
          >
            {{ $t('message["721"]') }}
          </a>
          <a
            v-else
            :disabled="!isReady"
            href="javascript:;"
            @click="toLink(2)"
          >
            {{ tabTelTit }}
          </a>
          <span>|</span>
          <template>
            <a
              v-if="loginType === 1"
              :disabled="!isReady"
              href="javascript:;"
              @click="toLink(2)"
            >
              {{ tabTelTit }}
            </a>
            <a
              v-else
              :disabled="!isReady"
              href="javascript:;"
              @click="toLink(1)"
            >
              {{ tabAcountTit }}
            </a>
          </template>
          <span>|</span>
          <a
            :disabled="!isReady"
            :href="gcwLoginUrl"
          >
            {{ $t('message["1091"]') }}
          </a>
        </p>
        <p class="join-btn">
          <router-link :to="{name: 'AccountRegister'}">
            {{ $t('message["1636"]') }}
          </router-link>
        </p>
        <!-- {{ $t('message') }} -->
      </div>
    </div>
  </login-layout>
</template>
<script>
// import { fetchApi } from '@/common'
import AccountLogin from './login/UserLogin.vue'
import TelLogin from './login/TelLogin.vue'
import LoginLayout from '@/components/pc/account/LoginLayout'
import QwLogin from './login/QwLogin'
import { getLang } from '@/lib/storage'
import { mapActions } from 'vuex'
export default {
  'name': 'AccoutTelLogin',
  components: {
    AccountLogin,
    TelLogin,
    LoginLayout,
    QwLogin
  },
  data () {
    return {
      activeName: 'first',
      qwLoginUrl: 'javascript:;',
      gcwLoginUrl: 'javascript:;',
      isReady: false
    }
  },
  computed: {
    title () {
      return this.$i18n.t('message["1381"]')
    },
    tabAcountTit () {
      return this.$i18n.t('message["1568"]')
    },
    tabTelTit () {
      return this.$i18n.t('message["1109"]')
    },
    loginType () {
      return this.$route.query.logintype * 1 || 3
    },
    loginTit () {
      return this.loginType === 1 ? this.tabAcountTit : this.tabTelTit
    }
  },
  async mounted () {
    const fromurl = this.$route.query.fromurl || ''
    const chain = await this.getQwGcUrl()
    chain.params({ fromurl: fromurl })
      .onSuccess(res => {
        const { qwLoginUrl, gcwLoginUrl } = res
        this.qwLoginUrl = qwLoginUrl
        this.gcwLoginUrl = gcwLoginUrl
        this.isReady = true
      })
      .fetch()
  },
  methods: {
    ...mapActions('account/login', ['getQwGcUrl']),
    getLang,
    toLink (type) {
      this.$router.push({ name: 'AccountLogin', query: { ...this.$route.query, logintype: type } })
    }
  }
}
</script>

<style lang="scss" scoped>
  .other-login {
    margin-top: 40px;
    padding: 20px 0 10px;
    text-align: center;
    line-height: 24px;
    border-top: 1px solid #ccc;
    position: relative;
    h4 {
      left: 0;
      height: 22px;
      padding: 0 10px;
      background: #fff;
      line-height: 22px;
      color: #b3b3b3;
      width:114px;
      margin: -31px auto 16px;
    }

    // p {
    //   padding: 6px 0;
    // }

    p span {
      color: #ccc;
      margin: 0 5px;
    }

    .join-btn {
      padding-top: 24px;
    }
  }
  .login-container::v-deep {
    .login-header {
      padding-bottom: 24px !important;
    }
    .login-tit{
      height: 24px;
      line-height: 24px;
      text-align: center;
      margin-bottom: 32px;
    }
  }
</style>
